import { render, staticRenderFns } from "./FrontPageCustom.vue?vue&type=template&id=02187dc3"
import script from "./FrontPageCustom.vue?vue&type=script&lang=js"
export * from "./FrontPageCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports